import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-cp-avatar',
  imports: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: ` <p>cp-avatar works!</p> `,
  styles: ``,
})
export class CpAvatarComponent {}
